import React, { useState } from 'react'
import emailjs from 'emailjs-com';
import './ServicesAll.scss'
import { Helmet } from "react-helmet";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"
import { useNavigate } from 'react-router-dom';
import Chimney3 from '../../Images/Chimney3.jpeg'
import bgnobgs from '../../Images/bgnobgs.png'
import AreaData from '../ServicesPage/AreaData'

export default function ServicesAll() {
    const navigate = useNavigate()


    return (
        <div className="ServicesAll">
            <Helmet>
                <title>Services | Master Air Duct - Air Duct, Chimney & Dryer Vent</title>
                <meta name="title" property="title" content="Services | Master Air Duct" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Services | Master Air Duct" data-react-helmet="true" />
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.masterairducts.com/og.jpg" data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.masterairducts.com/services" data-react-helmet="true" />
                <link rel="canonical" href="https://www.masterairducts.com/services" />
                <meta name="description" content="Master Air Duct full service catalog — air duct cleaning, duct sealing, duct repair, HVAC duct cleaning, dryer vent cleaning, chimney sweep, and more. Call 866-605-4089." data-react-helmet="true" />
                <meta name="og:description" property="og:description" content="Master Air Duct full service catalog." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Master Air Duct" data-react-helmet="true" />
                <meta name="keywords" content="air duct cleaning, dryer vent cleaning, chimney sweep, air duct repair, duct sealing, HVAC duct cleaning, indoor air quality, Master Air Duct" data-react-helmet="true" />
                <meta name="robots" content="index, follow, max-image-preview:large" />
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "name": "Master Air Duct — Services",
                    "url": "https://www.masterairducts.com/services",
                    "itemListElement": AreaData.map((A, i) => ({
                        "@type": "ListItem",
                        "position": i + 1,
                        "name": A.Title,
                        "url": `https://www.masterairducts.com${A.Path}`
                    }))
                })}</script>
            </Helmet>
            <div className="ServicesAllTitle">
                <h1>Comprehensive Air Duct, Chimney & Dryer Vent Services</h1>
                <h2>At Master Air Duct, we offer a full range of professional home services — air duct cleaning, sealing, and repair; chimney sweep and inspection; dryer vent cleaning and installation. Our skilled technicians keep your home safe, clean, and energy efficient. Explore our services below and trust Master Air Duct to deliver the excellence and reliability you deserve.</h2>
            </div>
            <div className="ServicesAllLsit">
                {AreaData.map((A, index) =>
                    <a href={A.Path} className="Header1BoxMenuBox">
                        
                        <div className="ServicesAllBox">
                            <h2>{A.Title}</h2>
                            <h6>{A.TitleShortVery}</h6>
                            <h4>{A.Full}</h4>
                            <h5>EXPLORE THIS SERVICE</h5>
                        </div>
                    </a>
                )}
            </div>

            <NavigatorPath />

        </div>
    )
}

